import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CrmMini.module.css';

function CrmMini() {
  return (
    <div className={styles.card}>
      <div className={styles.topStatBox}>
        <div>
          <div className={styles.statLabel}>Active Contacts</div>
          <span className={styles.statNumber}>37</span>
        </div>
        <button className={styles.expandIcon}>⛶</button>
      </div>

      <h3 className={styles.cardTitle}>CRM</h3>
      <span className={styles.cardCategory}>Client Insights</span>
      <p className={styles.cardDescription}>
        Track contacts, monitor sales activity, and gain real-time insights into customer engagement.
      </p>

      <div className={styles.cardFooter}>
        <Link to="/Dashboard/resellers/crm" className={styles.viewLink}>View full page →</Link>
      </div>
    </div>
  );
}

export default CrmMini;
